import Input from '@/components/form/Input';
import Select from '@/components/form/Select';

import { TIME_ZONES } from '../../enums';

const FormGeneral = () => {
  return (
    <>
      <Input name="name" label="Region Name" autoComplete="off" />
      <Select
        name="timeZone"
        label="Time Zone"
        options={Object.entries(TIME_ZONES).map(([key, value]) => ({
          value: key,
          label: value
        }))}
      />
    </>
  );
};

export default FormGeneral;
